import { transformToDefaultBlock } from '../../Block/BlockTransformers';
import {
    TopNabvarUspType,
    TopNavbarDetailsResource,
    TopNavbarInterface,
} from './TopNavbar';

export const transformToUsp = (resource: TopNavbarDetailsResource['usps'][number]) => ({
    id: resource.id,
    type: resource.type as TopNabvarUspType,
    title: resource.title,
    data: resource.data,
});

export const transformToTopNavbar = (resource: TopNavbarDetailsResource): TopNavbarInterface => {
    const defaultBlock = transformToDefaultBlock(resource);

    const usps = resource?.usps
        ? resource.usps.map((usp) => transformToUsp(usp))
        : [];

    return {
        ...defaultBlock,
        usps,
        links: resource.links,
    };
};
